.section,
.viewport {
  height: 100svh;
  min-height: 40rem;
}

.section {
  overflow: hidden;
}

.viewport {
  position: relative;
  display: grid;
  place-items: center;
  width: 100%;
  isolation: isolate;
}

.videoLayer,
.overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.videoLayer {
  z-index: var(--z-media);
  overflow: hidden;
  opacity: 1;
  filter: blur(0);
  will-change: opacity, filter;
}

.video,
.mediaPoster,
.wechatAnimation {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  will-change: transform, opacity;
}

.mediaPoster,
.wechatAnimation {
  position: absolute;
  inset: 0;
}

.mediaPoster {
  z-index: 0;
}

.video,
.wechatAnimation {
  position: relative;
  z-index: 1;
}

.wechatAnimation {
  opacity: 0;
  transition: opacity var(--duration-normal) ease;
}

.mediaReady {
  opacity: 1;
}

.overlay {
  z-index: var(--z-overlay);
  background:
    linear-gradient(180deg, rgb(0 0 0 / 10%) 0%, rgb(5 5 5 / 90%) 100%),
    linear-gradient(90deg, rgb(5 5 5 / 28%), transparent 25% 75%, rgb(5 5 5 / 28%));
}

.content {
  position: relative;
  z-index: var(--z-content);
  display: flex;
  width: min(calc(100% - (var(--page-margin) * 2)), var(--text-width-hero));
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.titleMask {
  width: 100%;
  overflow: hidden;
  padding-block: 0.08em;
}

.title {
  display: flex;
  width: 100%;
  max-width: var(--text-width-hero);
  margin-inline: auto;
  flex-direction: column;
  align-items: center;
  gap: clamp(0.75rem, 1.6vw, 1.5rem);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-display);
}

.primaryTitle {
  font-size: var(--font-size-hero);
  line-height: 1;
  white-space: nowrap;
}

.projectTitle {
  max-width: 52rem;
  font-size: clamp(1.5rem, 2.5vw, 2.5rem);
  font-weight: var(--font-weight-medium);
  letter-spacing: 0;
  line-height: 1.3;
  text-wrap: balance;
}

.support {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.subtitle {
  margin-top: var(--space-m);
  color: var(--color-text-primary);
  font-size: var(--font-size-subheading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-subheading);
  text-wrap: balance;
}

.subtitleMobile {
  display: none;
}

.body {
  max-width: var(--text-width-body);
  margin-top: var(--space-s);
  color: var(--color-text-secondary);
  line-height: var(--line-height-body);
}

.scrollIndicator {
  display: flex;
  min-width: 8rem;
  margin-top: var(--space-m);
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: var(--color-text-secondary);
  font-family: var(--font-display);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-ui);
  text-transform: uppercase;
}

.scrollLine {
  width: 1px;
  height: 2.5rem;
  background: linear-gradient(to bottom, var(--color-secondary), transparent);
  animation: scrollPrompt 1.8s ease-in-out infinite;
  transform-origin: top;
}

@keyframes scrollPrompt {
  0%,
  100% {
    opacity: 0.35;
    transform: scaleY(0.45);
  }

  50% {
    opacity: 1;
    transform: scaleY(1);
  }
}

@media (max-width: 47.9375rem) {
  .section,
  .viewport {
    min-height: 38rem;
  }

  .viewport {
    place-items: end center;
  }

  .content {
    padding-bottom: clamp(3.5rem, 10vh, 6rem);
  }

  .overlay {
    background: linear-gradient(
      180deg,
      rgb(0 0 0 / 5%) 0%,
      rgb(5 5 5 / 48%) 48%,
      rgb(5 5 5 / 96%) 100%
    );
  }

  .title {
    gap: 0.75rem;
  }

  .primaryTitle {
    line-height: 1.05;
  }

  .projectTitle {
    max-width: 22rem;
    font-size: clamp(1.125rem, 5vw, 1.375rem);
    line-height: 1.4;
  }

  .subtitle {
    margin-top: var(--space-s);
  }

  .subtitleDesktop {
    display: none;
  }

  .subtitleMobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.12em;
    line-height: 1.35;
  }

  .subtitleMobile > span {
    white-space: nowrap;
  }

  .body {
    margin-top: var(--space-xs);
  }

  .scrollIndicator {
    margin-top: var(--space-s);
  }
}

@media (orientation: landscape) and (max-height: 31.25rem) {
  .section,
  .viewport {
    min-height: 31.25rem;
  }

  .content {
    padding-block: var(--space-m);
  }
}

@media (prefers-reduced-motion: reduce) {
  .scrollLine {
    animation: none;
  }
}
